import React from "react";
import { Box, Container } from "@chakra-ui/react";
import DeemedDhakaMedicalCollegeCard from "./section-deemed/DeemedDhakaMedicalCollegeCard";
import DeemedHeaderSection from "./section-deemed/DeemedHeaderSection";
import DeemedQuickFactsSection from "./section-deemed/DeemedQuickFactsSection";
import DeemedHighlightsSection from "./section-deemed/DeemedHighlightsSection";
import DeemedFacilitiesSpecializationsSection from "./section-deemed/DeemedFacilitiesSpecializationsSection";
import DeemedCoursesSection from "./section-deemed/DeemedCoursesSection";
import DeemedAdmissionProcessSection from "./section-deemed/DeemedAdmissionProcessSection";
import DeemedEntranceExamsSection from "./section-deemed/DeemedEntranceExamsSection";
import DeemedFAQsSection from "./section-deemed/DeemedFAQsSection";
import DeemedContactSection from "./section-deemed/DeemedContactSection";

const DeemedCollegeDetails = ({ college }) => {
 if (!college) return null;

 const fixString = (val) => (typeof val === "string" ? val : "N/A");

 return (
  <Container maxW="container.xl" py={8}>
   <Box bg="white" boxShadow="md" borderRadius="lg" overflow="hidden">
    <DeemedDhakaMedicalCollegeCard college={college} />
    <DeemedHeaderSection
     collegeName={fixString(college.collegename)}
     universityDescription={fixString(college.universityDescription)}
    />
    <Box px={6} py={4}>
     <DeemedQuickFactsSection
      established={fixString(college.established)}
      type={fixString(college.collegetype)}
      location={fixString(college.location)}
      affiliatedBy={fixString(college.affiliatedby)}
      approvals={
       Array.isArray(college.approval) ? college.approval.join(", ") : "N/A"
      }
      collegeCategory={fixString(college.collegecategory)}
     />

     <DeemedHighlightsSection highlights={college?.highlights} />

     <DeemedFacilitiesSpecializationsSection
      facilities={college?.facilities}
      specializations={college?.specializations}
     />

     <DeemedCoursesSection courses={college.courses} />

     <DeemedAdmissionProcessSection
      admissionProcess={
       typeof college.admissionProcess === "string"
        ? college.admissionProcess.split(".")
        : []
      }
     />

     <DeemedEntranceExamsSection
      entranceExams={college.entranceExams}
      hostelFacilities={college.hostelFacilities?.boys || {}}
     />

     <DeemedFAQsSection faqs={college?.faq} />

     <DeemedContactSection
      website={fixString(college?.website)}
      email={fixString(college?.mail)}
      brochureLink={fixString(college?.pdf)}
     />
    </Box>
   </Box>
  </Container>
 );
};

export default DeemedCollegeDetails;
